import { DocumentationRequiredType, DocumentStatus, PaymentMethodType, RequiredFile } from '@nemuru-eng/js-api-client';
import { useEffect } from 'react';

import { RequiredFileCard } from '@/components/modules/Documentation/components/DocumentationDetails/components/RequiredFileCard';
import { hashLinkId } from '@/components/modules/Documentation/constants/hashLinkId';
import { DocumentationMode } from '@/components/modules/Documentation/types/DocumentationMode';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { useTranslation } from '@/components/shared/hooks/useTranslation';
import { PageHighlightTypeName } from '@/config/types';
import { usePageContext } from '@/contexts/PageContext/PageContext';

interface RequiredFilesListProps {
  requiredFiles: RequiredFile[];
  documentationRequiredType: DocumentationRequiredType;
  documentationRequiredId: string;
  mode: DocumentationMode;
  paymentMethodType: PaymentMethodType;
  paymentMethodId: string;
  borrowerId?: string;
}

export function RequiredFilesList({
  requiredFiles,
  documentationRequiredType,
  documentationRequiredId,
  mode,
  paymentMethodType,
  borrowerId,
  paymentMethodId,
}: RequiredFilesListProps) {
  const { getTextIdTranslation } = useTranslation();
  const {
    state: { loanHighlights },
    actions,
  } = usePageContext();

  const setHighlight = () => {
    actions.addLoanHighlights([
      {
        textId: 'DOCUMENTATION_INCIDENCE',
        type: PageHighlightTypeName.INCIDENCE,
        hashId: hashLinkId,
      },
    ]);
  };

  useEffect(() => {
    const hasIncidence = requiredFiles.some((file) => file.status === DocumentStatus.INCIDENCE);
    const incidenceReported = loanHighlights.some((file) => file.hashId === hashLinkId);
    if (hasIncidence && !incidenceReported) setHighlight();
  }, []);

  if (!requiredFiles.length) {
    return <PendingDataWarning tId={'NO_REQUIRED_DOCUMENTS'} />;
  }

  return (
    <>
      {requiredFiles
        .sort((a, b) => (getTextIdTranslation(a.name) > getTextIdTranslation(b.name) ? 1 : -1))
        .map((requiredFile, key) => (
          <RequiredFileCard
            key={key}
            requiredFile={requiredFile}
            documentationRequiredType={documentationRequiredType}
            documentationRequiredId={documentationRequiredId}
            paymentMethodId={paymentMethodId}
            paymentMethodType={paymentMethodType}
            mode={mode}
            borrowerId={borrowerId}
          />
        ))}
    </>
  );
}
